module.exports = __webpack_public_path__ + "img/favicon.e56b3a6a.png";